import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import theme from 'styled-theming';
import { maxWidthLayoutStyles } from '../../utils/styleHelpers.js';
import { BANNER_VARIANTS } from './constants.js';
export { BANNER_VARIANTS } from './constants.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
const Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "banner__Wrapper",
  componentId: "sc-oe03ar-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  flex-shrink: 0;\n  display: flex;\n  z-index: 1;\n\n  text-shadow: ", ";\n  box-shadow: 0 3px 4px -3px rgba(0, 0, 0, 0.2),\n    0 -3px 4px -3px rgba(0, 0, 0, 0.2);\n\n  background-color: ", ";\n  color: ", ";\n\n  a {\n    color: ", ";\n\n    &:hover,\n    &:focus,\n    &:active {\n      color: ", ";\n    }\n  }\n\n  ", "\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.textShadows.default;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.accents.dark;
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colors.contrastText;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.contrastText;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.colors.contrastText;
}, _ref6 => {
  let {
    theme: {
      colors
    },
    variant
  } = _ref6;
  switch (variant) {
    case BANNER_VARIANTS.HIGHLIGHT:
      return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          background-color: ", ";\n          color: ", ";\n          text-shadow: none;\n\n          a {\n            color: ", ";\n\n            &:hover,\n            &:focus,\n            &:active {\n              color: ", ";\n            }\n          }\n        "])), colors.brandAccents.lightTeal, colors.text, colors.text, colors.text);
    case BANNER_VARIANTS.PRIMARY:
      return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), colors.primary.main);
    case BANNER_VARIANTS.SECONDARY:
      return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), colors.secondary.main);
    case BANNER_VARIANTS.PREMIUM:
      return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n          background-color: ", ";\n          color: ", ";\n\n          a {\n            color: ", ";\n\n            &:hover,\n            &:focus,\n            &:active {\n              color: ", ";\n            }\n          }\n        "])), colors.brandAccents.purple, colors.brandAccents.lightTeal, colors.brandAccents.lightTeal, colors.brandAccents.lightTeal);
    case BANNER_VARIANTS.PROMO:
      return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), colors.brandAccents.red);

    // no default
  }
});

const DefaultBannerTextStyles = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  text-align: center;\n\n  [dir='rtl'] & {\n    font-family: ", ";\n    font-weight: bold;\n    text-transform: none;\n  }\n\n  ", "\n"])), _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.fonts.heading;
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.rtlFonts.heading;
}, theme('name', {
  pureGym: "\n      text-transform: uppercase;\n    "
}));
const PrimaryText = /*#__PURE__*/styled.span.withConfig({
  displayName: "banner__PrimaryText",
  componentId: "sc-oe03ar-1"
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", "\n\n  ", " {\n    font-size: ", ";\n  }\n"])), DefaultBannerTextStyles, _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.mediaQueries.md;
}, _ref10 => {
  let {
    theme
  } = _ref10;
  return theme.fontSizes.large;
});
const SecondaryText = /*#__PURE__*/styled.span.withConfig({
  displayName: "banner__SecondaryText",
  componentId: "sc-oe03ar-2"
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", "\n\n  margin-inline-start: ", ";\n  font-size: ", ";\n\n  ", " {\n    font-size: ", ";\n  }\n"])), DefaultBannerTextStyles, _ref11 => {
  let {
    theme
  } = _ref11;
  return theme.spacing.baseSpacing;
}, _ref12 => {
  let {
    theme
  } = _ref12;
  return theme.fontSizes.small;
}, _ref13 => {
  let {
    theme
  } = _ref13;
  return theme.mediaQueries.md;
}, _ref14 => {
  let {
    theme
  } = _ref14;
  return theme.fontSizes.standard;
});
const ContentWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "banner__ContentWrapper",
  componentId: "sc-oe03ar-3"
})(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: ", ";\n  text-decoration: none;\n\n  ", "\n"])), _ref15 => {
  let {
    theme
  } = _ref15;
  return "".concat(theme.spacing.halfSpacing, " ").concat(theme.spacing.baseSpacing);
}, _ref16 => {
  let {
    theme,
    href
  } = _ref16;
  return href && css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n      &:hover,\n      &:focus,\n      &:active {\n        background-color: ", ";\n\n        ", ",\n        ", " {\n          text-decoration: underline;\n        }\n      }\n    "])), theme.colors.opacities.subtle, PrimaryText, SecondaryText);
});
const BannerContent = /*#__PURE__*/styled.div.withConfig({
  displayName: "banner__BannerContent",
  componentId: "sc-oe03ar-4"
})(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  justify-content: center;\n\n  ", "\n"])), maxWidthLayoutStyles);
const Banner = /*#__PURE__*/forwardRef(function Banner(_ref17, ref) {
  let {
    children,
    linkProps,
    offerCode,
    primaryText,
    secondaryText,
    to,
    variant = BANNER_VARIANTS.PRIMARY,
    ...rest
  } = _ref17;
  return /*#__PURE__*/jsx(Wrapper, {
    ref: ref,
    variant: variant,
    ...rest,
    children: /*#__PURE__*/jsx(ContentWrapper, {
      href: to,
      as: to ? 'a' : 'div',
      ...linkProps,
      children: /*#__PURE__*/jsxs(BannerContent, {
        children: [primaryText ? /*#__PURE__*/jsx(PrimaryText, {
          children: primaryText
        }) : null, secondaryText || offerCode ? /*#__PURE__*/jsxs(SecondaryText, {
          children: [secondaryText, " ", offerCode]
        }) : null, children]
      })
    })
  });
});

export { Banner };
